export default [
  {
    label: 'Layout',
    options: [
      {
        name: 'Overview',
        href: 'layout',
      },
      {
        name: 'Grid',
        href: 'grid',
      },
    ],
  },
  {
    label: 'Brand',
    options: [
      {
        name: 'Typography',
        href: 'typography',
      },
      {
        name: 'Colors',
        href: 'colors',
      },
      {
        name: 'Icons',
        href: 'icons',
      },
    ],
  },
  {
    label: 'Components',
    options: [
      {
        name: 'Alerts',
        href: 'alerts',
      },
      {
        name: 'Buttons',
        href: 'buttons',
      },
      {
        name: 'Breadcrumbs',
        href: 'breadcrumbs',
      },
      {
        name: 'Cards',
        href: 'cards',
      },
      {
        name: 'Card',
        href: 'card',
      },
      {
        name: 'Collapse',
        href: 'collapse',
      },
      {
        name: 'Date Picker',
        href: 'datepicker',
      },
      {
        name: 'Tabs',
        href: 'tabs',
      },
      {
        name: 'Header',
        href: 'header',
      },
      {
        name: 'Mobile Subheader',
        href: 'mobilesubheader',
      },
      {
        name: 'Lists',
        href: 'lists',
      },
      {
        name: 'Footer',
        href: 'footer',
      },
      {
        name: 'Forms',
        href: 'forms',
      },
      {
        name: 'Tables',
        href: 'tables',
      },
      {
        name: 'Modal',
        href: 'modal',
      },
      {
        name: 'Panel',
        href: 'panel',
      },
      {
        name: 'Menu',
        href: 'menu',
      },
      {
        name: 'Badges',
        href: 'badges',
      },
      {
        name: 'Toggle',
        href: 'toggle',
      },
      {
        name: 'Dialog',
        href: 'dialog',
      },
    ],
  },
  {
    label: 'Utilities',
    options: [
      {
        name: 'Clearfix',
        href: 'clearfix',
      },
      {
        name: 'Display',
        href: 'display',
      },
      {
        name: 'Flex',
        href: 'flex',
      },
      {
        name: 'Float',
        href: 'float',
      },
      {
        name: 'Screenreaders',
        href: 'screenreaders',
      },
      {
        name: 'Sizing',
        href: 'sizing',
      },
      {
        name: 'Spacing',
        href: 'spacing',
      },
      {
        name: 'Text',
        href: 'text',
      },
      {
        name: 'Print',
        href: 'print',
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/utils/sections.js